import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { negotiationsHistoryV2Service } from '../services/negotiations-history-v2.service'

/**
 * El historial de estados, ya contra API v2.
 *
 * Se indexa por `neg_` y no por el `_id` con el que se piden las otras lecturas de esta
 * pantalla: mezclar las dos identidades en un mismo árbol de claves haría que una
 * invalidación fallara en silencio.
 */
export function useNegotiationHistoryV2Query(publicId: string | null) {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''

  return useQuery({
    queryKey: queryKeys.negotiations.historyV2(publicId),
    queryFn: async () => await negotiationsHistoryV2Service.list(accessToken, publicId ?? ''),
    // Sin `neg_` no hay a qué preguntarle, y sin token v2 la sesión entró por el carril
    // legacy: en los dos casos no se pide, en vez de tirar un 401.
    enabled: Boolean(publicId) && Boolean(accessToken),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 30_000
  })
}
